const firebaseConfig = {
    apiKey: "AIzaSyAWY25gQ-GOpHFtXg4A2T5KZL-XJKrwANk",
    authDomain: "dining-out-project.firebaseapp.com",
    projectId: "dining-out-project",
    storageBucket: "dining-out-project.appspot.com",
    messagingSenderId: "264885025958",
    appId: "1:264885025958:web:ba48ce302fcb58bf8f8867"
  };


export default firebaseConfig;